// import React, { useEffect } from "react";
// import AOS from "aos";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/Omnix/Section1";
import Section2 from "../includes/Omnix/Section2";
import Section3 from "../includes/Omnix/Section3";
import Section4 from "../includes/Omnix/Section4";
import Section5 from "../includes/Omnix/Section5";
import Section6 from "../includes/Omnix/Section6";
import Section7 from "../includes/Omnix/Section7";
import Section8 from "../includes/Omnix/Section8";

const Omnix = ({ devUrl }) => {

 const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/omnix",
    },
    name: "OMNIX AI",
    headline: "OMNIX AI | ExD Digital",
    description: "The multi agent AI platform that debates your problem, challenges assumptions, and delivers one confident answer.",
    image: "https://www.exddigital.com/images/omnix/banner-inner.png",
    author: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        // ✅ Fixed — use .webp not .png
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
    datePublished: "2026-04-15",
    dateModified: "2026-04-15",
  };

  return (
    <>
      <Helmet>
        <title>OMNIX AI</title>
        <meta
          name="description"
          content="The multi agent AI platform that debates your problem, challenges assumptions, and delivers one confident answer to turn complexity into clarity in minutes."
        />
        <link rel="canonical" href="https://www.exddigital.com/omnix" />

        {/* Open Graph */}
        <meta property="og:title" content="OMNIX AI | ExD Digital" />
        <meta
          property="og:description"
          content="The multi agent AI platform that debates your problem, challenges assumptions, and delivers one confident answer to turn complexity into clarity in minutes."
        />
        <meta property="og:url" content="https://www.exddigital.com/omnix" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.exddigital.com/images/omnix/banner-inner.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OMNIX AI | ExD Digital" />
        <meta
          name="twitter:description"
          content="The multi agent AI platform that debates your problem, challenges assumptions, and delivers one confident answer to turn complexity into clarity in minutes."
        />
        <meta name="twitter:image" content="https://www.exddigital.com/images/omnix/banner-inner.png" />

        {/* ✅ Clean — no inline spreading */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <main className="our-ai-main">
        <article className="omnix">
            <Section1 url={devUrl}/>
            <Section2 url={devUrl}/>
            <Section8 url={devUrl}/>
            <Section3 url={devUrl} />
            <Section4 url={devUrl} />
            {/* <Section5 url={devUrl} />
            <Section6 url={devUrl} /> */}
            <Section7 url={devUrl} />
        </article>
      </main>
    </>
  );
};

export default Omnix;